module.exports = "/images/UnitedKingdom.png?1dd90caba4f8d4aaf38df997ca0ec0e6";